













import Vue from 'vue'

import Default from '@/layout/Default.vue'

import Hero from '@/component/Hero.vue'
import Content from '@/component/Content.vue'
import Process from '@/component/Process.vue'
import Partner from '@/component/Partner.vue'

import Testimonial from '@/component/Testimonial.vue'

export default Vue.extend({
  name: 'Home',
  components: {
    Default,

    Hero,
    Content,
    Process,
    Partner,

    Testimonial
  }
});
